var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quill"},[_c('div',{ref:"editor",attrs:{"id":_vm.editorId,"name":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }